"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = brandingSettings;
var _types = require("../../actions/branding/types");
var _Branding = require("@studio/constants/Branding");
var _types2 = require("../../actions/types");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function brandingSettings() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var type = action.type,
    theme = action.payload;
  if (type === "".concat(_types.GET_BRANDING_SETTINGS, "_SUCCESS")) {
    var fontData = {
      fonts: {
        heading: {
          name: theme.fonts.heading.name,
          url: theme.fonts.heading.url
        },
        body: {
          name: theme.fonts.body.name,
          url: theme.fonts.body.url
        }
      }
    };
    return theme !== null && theme !== void 0 && theme.secondary ? _objectSpread({
      secondary: {
        block: {
          accent: theme.secondary.block.accent,
          container: theme.secondary.block.container
        }
      }
    }, fontData) : _objectSpread({}, fontData);
  } else if (type === "".concat(_types.GET_BRANDING_SETTINGS, "_FAILURE")) {
    return _Branding.DEFAULT_BRANDING;
  }
  if (type === _types2.SYNC_BRANDING_SETTINGS) {
    return theme;
  }
  return state;
}